import { View, Text, TouchableOpacity } from "react-native";
import React from "react";
import HistoryIcon from "../../assets/svg/HistoryIcon";
import WalletIcon from "../../assets/svg/WalletIcon";
import PlusIcon from "../../assets/svg/PlusIcon";
import MyText from "../../components/custom/MyText";
import translate from "../../functions/translate";
import {
  darkGreen,
  gray,
  primary,
  shadowSm,
  white,
  orange,
  success,
} from "../../colors";
import { LinearGradient } from "expo-linear-gradient";
import { useState } from "react";
import { width } from "../../imports";
import StepSlide from "../../components/animation/StepSlide";
import MyInputWithLabel from "../../components/custom/MyInputWithLabel";
import MyButton from "../../components/custom/MyButton";
import TransactionItem from "../../components/custom/TransactionItem";
import { useEffect } from "react";
import getBalance from "../../api/wallet/getBalance";
import { useDispatch, useSelector } from "react-redux";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButton,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import getTransactionList from "../../api/wallet/getTransactionList";
import { ScrollView } from "react-native-gesture-handler";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import PaymentServiceSelectModal from "../../components/modals/PaymentServiceSelectModal";
import { setPaymentServiceSelectModal } from "../../redux/modal/modalAction";
import { currencyFormat } from "../../functions/functions";
import getSettlementList from "../../api/wallet/getSettlementList";
import settlementRequest from "../../api/wallet/settlementRequest";
import { Toast } from "react-native-toast-message/lib/src/Toast";
import Fade from "../../components/animation/Fade";
let interval = 0;
export default function Wallet(props) {
  const navigation = useNavigation();
  const parentMode = props.route.params.mode;
  const [mode, setMode] = useState("charge");
  const [input, setInput] = useState({ amount: 0 });
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [settlements, setSettlements] = useState([]);
  const main = useSelector((store) => store.main);
  const dispatch = useDispatch();
  const [depositStep, setDepositStep] = useState(1);

  const currency = main.rtl ? "IR" : "US";

  useEffect(() => {
    getBalance(currency).then(({ data }) => {
      if (data.status === 200) {
        setBalance(data.inventory);
      }
    });

    interval = setInterval(() => {
      getBalance(currency).then(({ data }) => {
        if (data.status === 200) {
          setBalance(data.inventory);
        }
      });
    }, 2000);

    getTransactionList(currency).then(({ data }) => {
      setTransactions(data.data);
    });
    getSettlementList(currency).then(({ data }) => {
      setSettlements(data.data);
    });
    return () => clearInterval(interval);
  }, [props.changed]);

  useEffect(() => {
    if (parentMode === "transactions") {
      setMode("transactions");
    }
  }, [parentMode]);
  const isFocused = useIsFocused();

  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#fff"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
    }

  }, [isFocused]);
  const [settlementLoading, setSettlementLoading] = useState(false);
  const requestSettlement = () => {
    setSettlementLoading(true);
    settlementRequest(main.rtl ? "IR" : "USD")
      .then(({ data }) => {
        setSettlementLoading(false);
        if (data.status === 200) {
          Toast.show({
            type: "success",
            text1: main.rtl ? data.description.fa : data.description.en,
          });
        } else {
          Toast.show({
            type: "error",
            text1: main.rtl ? data.description.fa : data.description.en,
          });
        }
      })
      .catch(() => {
        setSettlementLoading(false);
      });
  };

  return (
    <View style={{ width: "100%", alignItems: "center", flex: 1 }}>
      <PaymentServiceSelectModal amount={+input.amount} currency={currency} />
      <KeyboardAwareScrollView
        keyboardShouldPersistTaps="handled"
        style={{ width: "100%" }}
        contentContainerStyle={{ alignItems: "center" }}
        enableOnAndroid
        extraHeight={70}
      >
        <View
          style={{
            marginVertical: 20,
            width: "92%",
            borderRadius: 10,

            borderColor: "#eee",
            ...shadowSm,
          }}
        >
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              padding: 5,
              justifyContent: "center",
            }}
          >
            <View style={{ transform: [{ scale: 1.5 }] }}>
              <WalletIcon />
            </View>
            <View>
              <MyText
                style={{
                  color: "#3B869A",
                  fontSize: 26,
                  marginHorizontal: 10,
                  marginTop: 10,
                }}
              >
                {translate("wallet")}
              </MyText>
            </View>
          </View>
          <View
            style={{
              width: "100%",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <View style={{ marginVertical: 15 }}>
              <MyText style={{ fontSize: 20, color: gray }}>
                {translate("your balance")}
              </MyText>
            </View>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              {/* {balance >= 1000 && (
              <View
                dir="ltr"
                style={{
                  flexDirection: "row",
                  direction: "ltr",
                  alignItems: "flex-end",
                }}
              >
                <MyText style={{ fontSize: 28 }}>{`${Math.floor(
                  balance / 1000
                )}`}</MyText>
                <MyText
                  style={{
                    fontSize: 20,
                    color: gray,
                    marginHorizontal: 2,
                    marginTop: -5,
                  }}
                >
                  {`${balance % 1000}`}
                </MyText>
              </View>
            )} */}

              <View
                dir="ltr"
                style={{
                  flexDirection: "row",
                  direction: "ltr",
                  alignItems: "flex-end",
                }}
              >
                <MyText style={{ fontSize: 28 }}>{`${currencyFormat(
                  balance
                )}`}</MyText>
              </View>

              <View style={{ marginHorizontal: 10 }}>
                <MyText style={{ fontSize: 22, color: primary }}>
                  {translate("currency")}
                </MyText>
              </View>
            </View>
          </View>
        </View>
        <Fade isShown={depositStep === 2}>
          <View style={{ width: "90%" }}>
            <MyText>{translate("enter money amount")}</MyText>
            <MyInputWithLabel
              name="amount"
              value={input.amount}
              setInput={setInput}
              style={{ width: "100%", marginTop: 20 }}
              keyboardType="number-pad"
            />
          </View>
        </Fade>

        <View
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginVertical: 20,
            width: "100%",
            paddingHorizontal: "6%",
            gap: 5,
          }}
        >
          <MyButton
            onPress={() => {
              if (depositStep === 1) {
                setDepositStep(2);
              } else if (depositStep === 2) {
                setDepositStep(1);
              }
            }}
            style={{
              backgroundColor: orange,
              borderRadius: 5,
              width: "50%",
              paddingHorizontal: 2,
              paddingVertical: 10,
            }}
            textStyle={{ fontSize: 14 }}
            text={depositStep === 1 ? "افزایش اعتبار" : "لغو"}
          />
          <MyButton
            loading={settlementLoading}
            onPress={
              depositStep === 1
                ? requestSettlement
                : () =>
                    input.amount !== 0 &&
                    input.amount !== "" &&
                    input.amount !== null &&
                    dispatch(setPaymentServiceSelectModal())
            }
            text={
              depositStep === 1 ? translate("request for settlement") : "پرداخت"
            }
            style={{
              backgroundColor: success,
              width: "50%",
              borderRadius: 5,
              paddingHorizontal: 2,
              paddingVertical: 10,
            }}
            textStyle={{ fontSize: 14 }}
          />
        </View>
        <View
          style={{
            width: "80%",
            backgroundColor: "#eaeaea",
            borderWidth: 1,
            borderColor: "#cccc",
            borderRadius: 15,
            flexDirection: "row",
          }}
        >
          <TouchableOpacity
            onPress={() => setMode("charge")}
            style={{
              minHeight: 40,
              flex: 1,
              borderRadius: 15,
              backgroundColor: mode === "charge" ? primary : "#eaeaea",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MyText style={{ color: mode === "charge" ? white : darkGreen }}>
              {translate("transactions")}
            </MyText>
          </TouchableOpacity>
          <TouchableOpacity
            onPress={() => setMode("transactions")}
            style={{
              minHeight: 40,
              flex: 1,
              borderRadius: 15,
              backgroundColor: mode === "transactions" ? primary : "#eaeaea",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <MyText
              style={{ color: mode === "transactions" ? white : darkGreen }}
            >
              {translate("settlements")}
            </MyText>
          </TouchableOpacity>
        </View>
        <View style={{ width: width, marginTop: 20, flex: 1 }}>
          <StepSlide nextStep={mode === "transactions"} style={{ flex: 1 }}>
            <View style={{ width: width, alignItems: "center" }}>
              <View style={{ width: "90%" }}>
                {transactions.map((transaction, index) => (
                  <TransactionItem
                    amount={transaction.amount}
                    date={transaction.date}
                    description={transaction.descreptions}
                    status={
                      main.rtl ? transaction.statusFa : transaction.status
                    }
                    refId={transaction.trackingCode}
                    key={index}
                  />
                ))}
              </View>
            </View>
            <View style={{ width: width, alignItems: "center", marginTop: 20 }}>
              <View style={{ width: "90%" }}>
                {settlements.map((transaction, index) => (
                  <TransactionItem
                    amount={transaction.amount}
                    date={transaction.dateCrate}
                    description={transaction.descreptions}
                    status={
                      main.rtl ? transaction.statusFa : transaction.status
                    }
                    refId={transaction.trackingCode}
                    key={index}
                  />
                ))}
              </View>
            </View>
          </StepSlide>
        </View>
        <View style={{ height: 100 }}></View>
      </KeyboardAwareScrollView>
    </View>
  );
}
